import { X } from "lucide-react";
import React, { ReactNode } from "react";
import { useSelector } from "react-redux";

import { IgIconButton, IgTypography } from "@intelligems/ig-theme";
import { ExperienceStatus } from "@intelligems/ig-types";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { SxProps } from "@mui/system";
import { ProductFilters } from "@src/components/MainApp/SharedProductPicker/list/ProductFilters";
import { useDispatch } from "@src/store";
import { PutExperienceStatus } from "@src/store/slices/experiences/types";
import {
  closeProductPicker,
  getProductPickerData,
  getProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import { GetProductPickerInfo } from "@src/store/slices/productPicker/types";
import { shouldIncludeIntelligemsProducts } from "@src/store/slices/productPicker/util/productPickerPolicy";

import { ProductSection } from "./list/ProductSection";
import { SelectedProductSection } from "./list/SelectedProductSection";
import { ProductPickerProvider } from "./ProductPickerProvider";
import { PutExperienceStatusView } from "./PutExperienceStatusView";

interface ProductPickerProps {
  getProductPickerInfo?: GetProductPickerInfo;
  isView?: boolean;
  experienceStatus?: ExperienceStatus;
  putExperienceStatus?: PutExperienceStatus;
  dialogActions?: ReactNode[];
  onCustomCloseFn?: () => void;
  slotProps?: {
    product?: {
      sx?: SxProps;
    };
  };
  loadVariants?: boolean;
}

export const ProductPicker = ({
  getProductPickerInfo,
  isView,
  experienceStatus,
  putExperienceStatus,
  dialogActions,
  slotProps,
  onCustomCloseFn,
  loadVariants,
}: ProductPickerProps) => {
  const theme = useTheme();
  const products = useSelector(getProductPickerSelectedProducts);

  const productPickerData = useSelector(getProductPickerData);
  const allowIgProducts = shouldIncludeIntelligemsProducts(
    productPickerData?.type
  );

  const dispatch = useDispatch();
  return (
    <ProductPickerProvider
      allowIgProducts={allowIgProducts}
      loadVariants={loadVariants}
    >
      <Grid
        container
        direction={"column"}
        sx={{
          border: `1px solid ${theme.igBorders.core.default}`,
          borderRadius: "8px",
          minWidth: "fit-content",
        }}
      >
        {putExperienceStatus !== undefined && (
          <PutExperienceStatusView status={putExperienceStatus} />
        )}
        {putExperienceStatus === undefined && (
          <>
            <Grid
              container
              direction={"row"}
              padding={6}
              alignItems={"center"}
              justifyContent={"space-between"}
              sx={{
                borderBottom: `1px solid ${theme.igBorders.core.default}`,
              }}
            >
              <Grid>
                <IgTypography variant={"h3"} fontWeight={600}>
                  Select products
                </IgTypography>
              </Grid>
              <Grid
                sx={{
                  height: "24px",
                  width: "24px",
                  position: "sticky",
                  right: theme.spacing(6),
                }}
              >
                <IgIconButton
                  onClick={() => {
                    dispatch(closeProductPicker());
                    if (onCustomCloseFn) {
                      onCustomCloseFn();
                    }
                  }}
                >
                  <X size={18} />
                </IgIconButton>
              </Grid>
            </Grid>
            <Grid
              container
              direction={"row"}
              wrap={"nowrap"}
              sx={{ height: "460px" }}
            >
              <Grid
                sx={{
                  borderRight: `1px solid ${theme.igBorders.core.default}`,
                }}
              >
                <ProductFilters allowIgProducts={allowIgProducts} />
              </Grid>
              <Grid sx={{ width: "620px" }}>
                <ProductSection
                  getProductPickerInfo={getProductPickerInfo}
                  isView={isView}
                  {...slotProps?.product}
                />
              </Grid>
              <Grid
                sx={{
                  width: "300px",
                  borderLeft: `1px solid ${theme.igBorders.core.default}`,
                }}
              >
                <SelectedProductSection
                  isView={isView}
                  experienceStatus={experienceStatus}
                  dialogActions={dialogActions}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              wrap={"nowrap"}
              sx={{
                borderTop: `1px solid ${theme.igBorders.core.default}`,
                height: "66px",
                paddingX: 6,
                paddingY: 4,
              }}
            >
              <Grid size={8}>
                <IgTypography>{products.length} products selected</IgTypography>
              </Grid>
              {dialogActions && (
                <Grid
                  columnSpacing={3}
                  container
                  justifyContent={"flex-end"}
                  direction={"row"}
                  sx={{
                    position: "sticky",
                    right: theme.spacing(6),
                  }}
                >
                  {dialogActions.map((action, index) => (
                    <Grid key={index}>{action}</Grid>
                  ))}
                </Grid>
              )}
            </Grid>
          </>
        )}
      </Grid>
      {/*<Box*/}
      {/*  justifyContent={"space-between"}*/}
      {/*  sx={{*/}
      {/*    display: "flex",*/}
      {/*    padding: "40px",*/}
      {/*    alignItems: "stretch",*/}
      {/*    justifyContent: "stretch",*/}
      {/*    ...sx,*/}
      {/*  }}*/}
      {/*>*/}
      {/*  {loadStatus === undefined && (*/}
      {/*    <>*/}
      {/*      <ProductSection*/}
      {/*        getProductPickerInfo={getProductPickerInfo}*/}
      {/*        isView={isView}*/}
      {/*        {...slotProps?.product}*/}
      {/*      />*/}
      {/*      <Box*/}
      {/*        sx={{*/}
      {/*          marginLeft: "20px",*/}
      {/*          width: "1px",*/}
      {/*          backgroundColor: "#eee",*/}
      {/*          marginRight: "20px",*/}
      {/*        }}*/}
      {/*      />*/}
      {/*      <SelectedProductSection*/}
      {/*        isView={isView}*/}
      {/*        experienceStatus={experienceStatus}*/}
      {/*        dialogActions={dialogActions}*/}
      {/*      />*/}
      {/*    </>*/}
      {/*  )}*/}
      {/*</Box>*/}
    </ProductPickerProvider>
  );
};
